import { useAuth } from '@saay/auth-web';
import { Button, Dialog } from '../kit.js';

import {
  ADMIN_IDLE_LIMIT_MS,
  ADMIN_IDLE_WARNING_LEAD_MS,
  type IdleClock,
  systemIdleClock,
  useIdleTimeout,
} from '../use-idle-timeout.js';

const IDLE_WARNING_FA = 'چون مدتی کاری انجام نداده‌اید، تا یک دقیقهٔ دیگر از حساب خارج می‌شوید';

/**
 * Signs the admin out after idle time (D-72). Activity is tracked in memory only; at one minute before
 * the limit a prototype-style dialog offers «ادامه کار» or «خروج» (Keycloak logout).
 */
export function IdleTimeoutGuard({ clock = systemIdleClock }: { readonly clock?: IdleClock } = {}) {
  const { controller } = useAuth();
  const { continueSession, phase, signOutNow } = useIdleTimeout({
    clock,
    enabled: true,
    limitMs: ADMIN_IDLE_LIMIT_MS,
    onTimeout: () => void controller.logout(),
    warningLeadMs: ADMIN_IDLE_WARNING_LEAD_MS,
  });

  return (
    <Dialog
      footer={
        <>
          <Button fullWidth onClick={continueSession} type="button">
            ادامه کار
          </Button>
          <Button fullWidth onClick={signOutNow} type="button" variant="secondary">
            خروج
          </Button>
        </>
      }
      onOpenChange={(open) => {
        if (!open) {
          continueSession();
        }
      }}
      open={phase === 'warning'}
      size="small"
      title={IDLE_WARNING_FA}
    />
  );
}
